import Grid from "@mui/material/Grid";
import DefaultLoader from "components/common/DefaultLoader";
import {
  TargetLossRatiosTable,
  selectModelKey,
} from "components/inputs/lossDevelopment/TargetLossRatios";
import * as labels from "config.labels";
import { useSelector } from "react-redux";
import { useModels } from "store/hooks/modelHooks";
import * as staticDataHooks from "store/hooks/staticDataHooks";
import { useTargetLossRatios } from "store/hooks/targetLossRatioHooks";

/*
 * The config-fixed Target Loss Ratios table (Inputs > Loss Development) laid
 * out for the Summary printout: the rows for the submission's model, or the
 * whole schedule when that model has none or none is selected. Visibility is
 * gated by the caller.
 */
const PrintTargetLossRatios = () => {
  const translateLabel = staticDataHooks.useTranslator("uiLabels");
  const { rows, isLoading } = useTargetLossRatios();
  const { models, isLoading: isLoadingModels } = useModels();
  const model = useSelector(selectModelKey);

  return (
    <Grid item xs={12} data-testid={"print-target-loss-ratios"}>
      <span className={"print-label"}>
        {translateLabel(labels.TARGET_LOSS_RATIOS_TITLE, {
          default: "Target Loss Ratios",
        })}
      </span>
      {isLoading || isLoadingModels ? (
        <DefaultLoader
          style={{
            width: "200px",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          size={60}
        />
      ) : (
        <TargetLossRatiosTable rows={rows} model={model} models={models} />
      )}
    </Grid>
  );
};

export default PrintTargetLossRatios;
